/**
 * Get the currency symbol for a given currency code
 */
export function getCurrencySymbol(currencyCode: string): string {
  const symbols: Record<string, string> = {
    USD: '$',
    EUR: '€',
    GBP: '£'
  };

  return symbols[currencyCode.toUpperCase()] || '$';
}

/**
 * Format a price with the appropriate currency symbol
 */
export function formatPrice(amount: number, currencyCode: string): string {
  const symbol = getCurrencySymbol(currencyCode);
  const formattedAmount = amount.toFixed(2);
  
  // EUR typically places symbol after the amount in some locales, but for consistency we'll use prefix
  return `${symbol}${formattedAmount}`;
}

